import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const SupplierDirectory = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedRegion, setSelectedRegion] = useState('all');

  const categories = [
  { value: 'all', label: 'All Categories' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'textiles', label: 'Textiles & Apparel' },
  { value: 'electronics', label: 'Electronics' },
  { value: 'chemicals', label: 'Chemicals' },
  { value: 'machinery', label: 'Machinery' },
  { value: 'food', label: 'Food & Beverages' }];


  const regions = [
  { value: 'all', label: 'All Regions' },
  { value: 'asia', label: 'Asia Pacific' },
  { value: 'europe', label: 'Europe' },
  { value: 'americas', label: 'Americas' },
  { value: 'mena', label: 'Middle East & Africa' }];


  const suppliers = [
  {
    id: 1,
    name: 'Shanghai Manufacturing Co.',
    category: 'Manufacturing',
    region: 'Asia Pacific',
    country: 'China',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1d28375fb-1764773756591.png",
    logoAlt: 'Modern industrial factory building with blue sky and Shanghai Manufacturing Co. branding on facade',
    rating: 4.8,
    reviews: 342,
    verified: true,
    specialties: ['Precision Parts', 'Metal Fabrication', 'Quality Control'],
    tradeVolume: '₹45 Cr',
    responseTime: '2 hours',
    certifications: ['ISO 9001', 'CE', 'RoHS']
  },
  {
    id: 2,
    name: 'European Textiles GmbH',
    category: 'Textiles & Apparel',
    region: 'Europe',
    country: 'Germany',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1848cc438-1765264932332.png",
    logoAlt: 'Elegant textile manufacturing facility with rows of colorful fabric rolls and European Textiles branding',
    rating: 4.9,
    reviews: 287,
    verified: true,
    specialties: ['Organic Cotton', 'Sustainable Fabrics', 'Custom Designs'],
    tradeVolume: '₹38 Cr',
    responseTime: '1 hour',
    certifications: ['GOTS', 'OEKO-TEX', 'Fair Trade']
  },
  {
    id: 3,
    name: 'TechSource Electronics Ltd.',
    category: 'Electronics',
    region: 'Asia Pacific',
    country: 'South Korea',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_16e28cb7a-1766309642072.png",
    logoAlt: 'High-tech electronics manufacturing plant with automated assembly lines and TechSource branding on glass building',
    rating: 4.7,
    reviews: 456,
    verified: true,
    specialties: ['PCB Assembly', 'IoT Devices', 'Consumer Electronics'],
    tradeVolume: '₹62 Cr',
    responseTime: '3 hours',
    certifications: ['ISO 14001', 'UL', 'FCC']
  },
  {
    id: 4,
    name: 'Global Chemicals Inc.',
    category: 'Chemicals',
    region: 'Americas',
    country: 'USA',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_106234a65-1764860946731.png",
    logoAlt: 'Modern chemical processing facility with steel tanks and pipelines under clear blue sky with Global Chemicals signage',
    rating: 4.6,
    reviews: 198,
    verified: true,
    specialties: ['Industrial Chemicals', 'Specialty Compounds', 'R&D Support'],
    tradeVolume: '₹28 Cr',
    responseTime: '4 hours',
    certifications: ['ISO 45001', 'REACH', 'EPA']
  },
  {
    id: 5,
    name: 'Precision Machinery Pvt Ltd',
    category: 'Machinery',
    region: 'Asia Pacific',
    country: 'India',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1f4fe474c-1764746934838.png",
    logoAlt: 'Industrial machinery workshop with large CNC machines and precision equipment with company logo on entrance',
    rating: 4.8,
    reviews: 312,
    verified: true,
    specialties: ['CNC Machines', 'Automation Systems', 'Custom Solutions'],
    tradeVolume: '₹52 Cr',
    responseTime: '2 hours',
    certifications: ['ISO 9001', 'CE', 'BIS']
  },
  {
    id: 6,
    name: 'Mediterranean Foods SA',
    category: 'Food & Beverages',
    region: 'Europe',
    country: 'Spain',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1bd087c1e-1765234329784.png",
    logoAlt: 'Mediterranean food processing facility with olive groves in background and traditional Spanish architecture with company branding',
    rating: 4.9,
    reviews: 423,
    verified: true,
    specialties: ['Olive Oil', 'Organic Products', 'Mediterranean Cuisine'],
    tradeVolume: '₹34 Cr',
    responseTime: '1 hour',
    certifications: ['HACCP', 'EU Organic', 'IFS Food']
  }];


  return (
    <section className="py-12 md:py-16 lg:py-20 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full text-sm md:text-base text-primary mb-4">
            <Icon name="Users" size={20} />
            <span>Verified Supplier Network</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Explore Our Supplier Directory
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-3xl mx-auto">
            Connect with 2,500+ verified suppliers across multiple industries and regions
          </p>
        </div>

        <div className="bg-card rounded-2xl p-4 md:p-6 shadow-lg border border-border mb-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Input
              type="search"
              placeholder="Search suppliers, products, or services..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)}
              className="md:col-span-1" />

            <Select
              options={categories}
              value={selectedCategory}
              onChange={setSelectedCategory}
              placeholder="Select category" />

            <Select
              options={regions}
              value={selectedRegion}
              onChange={setSelectedRegion}
              placeholder="Select region" />

          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {suppliers?.map((supplier) =>
          <div
            key={supplier?.id}
            className="bg-card rounded-xl shadow-lg border border-border overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1">

              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <div className="w-16 h-16 rounded-lg overflow-hidden bg-muted flex-shrink-0">
                      <Image
                      src={supplier?.logo}
                      alt={supplier?.logoAlt}
                      className="w-full h-full object-cover" />

                    </div>
                    <div className="min-w-0">
                      <h3 className="text-base md:text-lg font-bold text-foreground line-clamp-1">
                        {supplier?.name}
                      </h3>
                      <p className="text-xs md:text-sm text-muted-foreground">{supplier?.country}</p>
                    </div>
                  </div>
                  {supplier?.verified &&
                <div className="flex-shrink-0">
                      <Icon name="BadgeCheck" size={24} color="var(--color-success)" />
                    </div>
                }
                </div>

                <div className="flex items-center gap-2 mb-4">
                  <div className="flex items-center gap-1">
                    <Icon name="Star" size={16} color="var(--color-warning)" />
                    <span className="text-sm font-semibold text-foreground">{supplier?.rating}</span>
                  </div>
                  <span className="text-xs text-muted-foreground">({supplier?.reviews} reviews)</span>
                </div>

                <div className="space-y-3 mb-4">
                  <div className="flex items-center gap-2 text-sm">
                    <Icon name="Package" size={16} color="var(--color-primary)" />
                    <span className="text-muted-foreground">{supplier?.category}</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm">
                    <Icon name="TrendingUp" size={16} color="var(--color-success)" />
                    <span className="text-muted-foreground">Trade Volume: {supplier?.tradeVolume}</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm">
                    <Icon name="Clock" size={16} color="var(--color-accent)" />
                    <span className="text-muted-foreground">Response: {supplier?.responseTime}</span>
                  </div>
                </div>

                <div className="mb-4">
                  <h4 className="text-xs font-semibold text-foreground mb-2">Specialties</h4>
                  <div className="flex flex-wrap gap-2">
                    {supplier?.specialties?.map((specialty, index) =>
                  <span
                    key={index}
                    className="px-2 py-1 bg-primary/10 text-primary text-xs rounded-full">

                        {specialty}
                      </span>
                  )}
                  </div>
                </div>

                <div className="mb-4">
                  <h4 className="text-xs font-semibold text-foreground mb-2">Certifications</h4>
                  <div className="flex flex-wrap gap-2">
                    {supplier?.certifications?.map((cert, index) =>
                  <span
                    key={index}
                    className="px-2 py-1 bg-success/10 text-success text-xs rounded-full flex items-center gap-1">

                        <Icon name="Award" size={12} />
                        {cert}
                      </span>
                  )}
                  </div>
                </div>

                <div className="flex gap-2">
                  <Button
                  variant="default"
                  size="sm"
                  iconName="MessageSquare"
                  iconPosition="left"
                  fullWidth>

                    Contact
                  </Button>
                  <Button
                  variant="outline"
                  size="sm"
                  iconName="ExternalLink"
                  iconPosition="left">

                    View
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="text-center mt-8 md:mt-12">
          <Button
            variant="outline"
            size="lg"
            iconName="ArrowRight"
            iconPosition="right">

            View All 2,500+ Suppliers
          </Button>
        </div>
      </div>
    </section>);

};

export default SupplierDirectory;